import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gratipay': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111.1 8 0 119.1 0 256S111.1 504 248 504 496 392.9 496 256 384.9 8 248 8zM362.6 234.4L249.6 387.1 136.9 234.4C128.2 222.5 117.8 184 150.5 162.4 178.6 144.3 205.1 158.2 219 174.3 234.9 192.2 265.6 191.2 280.7 174.3 294.6 158.2 321.1 144.3 348.8 162.4 381.7 184 371.4 222.4 362.6 234.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gratipay.js
// module id = c9OS
// module chunks = 144